export default __webpack_public_path__ + "static/media/genre.637bb3c2.svg";